import { Page } from "navigation/types";
import { Route, Routes } from "react-router-dom";
import AddListingPagesRouter from "navigation/routers/AddStayRouter";
import AddHostInfoRouter from "navigation/routers/AddHostInfoRouter";
import AuthorPage from "containers/HostPagePublic/AuthorPage";
import PageCreateStripeAccount from "containers/PageCreateStripeAccount/PageCreateStripeAccount";
import SiteHeader from "containers/SiteHeader";
import RequireHostAuth from "application/features/hostAuth/requireHostAuth";
import PageStripeLogin from "containers/StripeLogin/StripeLogin";
import useWindowSize from "application/hooks/useWindowResize";
import FooterNav from "components/FooterNav";
import FooterNavHost from "components/FooterNavHost";
import { useSelector } from "react-redux";
import { Host } from "data/types/host";
import { selectCurrentHost } from "application/features/host/hostSlice";
import EditListingPage from "containers/EditListingFlows/EditListing/EditListingBase";
import EditListingSpace from "containers/EditListingFlows/EditListing/EditListingSpace";
import EditListingAmenities from "containers/EditListingFlows/EditListing/EditListingAmenities";
import PageMyListing from "containers/MyListing/PageMyListing";
import PageChooseListingType from "containers/AddListingFlows/ChooseListingType/PageChooseListingType";
import AddExperiencePagesRouter from "navigation/routers/AddExperienceRouter";
import AddHolidayPackagePagesRouter from "navigation/routers/AddHolidayPackageRouter";
import EditExperiencePage from "containers/EditListingFlows/EditExperience/EditListingBase";
import EditingAvailabilities from "containers/EditListingFlows/EditExperience/EditingAvailabilities";
import EditHolidayPackagePage from "containers/EditListingFlows/EditHolidayPackage/EditHolidayPackagePage";
import PageHostChat from "containers/PageHostChat/PageHostChat";
import PageHostReservations from "containers/HostReservations/PageHostReservations";
import HostStatsPage from "containers/HostStatsPage/HostStatsPage";
import InvoiceDetailsPage from "containers/HostReservations/InvoiceDetailsPage";

const HostPages: Page[] = [
  { path: "/info/*", component: AddHostInfoRouter },
  { path: "/bookings", component: PageHostReservations },
  { path: "/invoice/:bookingId", component: InvoiceDetailsPage },
  { path: "/stats", component: HostStatsPage },
  { path: "/new-property/*", component: AddListingPagesRouter },
  { path: "/new-experience/*", component: AddExperiencePagesRouter },
  { path: "/new-holiday-package/*", component: AddHolidayPackagePagesRouter },
  { path: "/new-listing/", component: PageChooseListingType },
  { path: "/edit-property/:id", component: EditListingPage },
  { path: "/edit-property/space/:id", component: EditListingSpace },
  { path: "/edit-property/amenities/:id", component: EditListingAmenities },
  { path: "/edit-experience/:id", component: EditExperiencePage },
  { path: "/edit-experience/availabilities/:id", component: EditingAvailabilities },
  { path: "/edit-holiday-package/:id", component: EditHolidayPackagePage },
  { path: "/stripe/connect-account", component: PageCreateStripeAccount },
  { path: "/stripe/login", component: PageStripeLogin },
  { path: "/", component: AuthorPage },
  { path: "/chat", component: PageHostChat },
  { path: "/my-properties", component: PageMyListing },

]

const HostPagesRouter = () => {
  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }
  const host: Host = useSelector(selectCurrentHost);

  return (
    <>
      <SiteHeader navType="HostNav"/>
      <Routes>
        <Route element={<RequireHostAuth />}>
          {HostPages.map(({ component, path }) => {
            const Component = component;
            return <Route key={path} element={<Component />} path={path} />;
          })}
        </Route>
      </Routes>
      {WIN_WIDTH < 1024 ? !host?.host_uuid ? <FooterNav /> : <FooterNavHost /> : null}

    </>

  )
}

export default HostPagesRouter;